import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import useFetchTriggerOptions from 'components/domain/automation/triggers/useFetchTriggerOptions';
import CustomSelectField from 'components/forms/customSelectField/CustomSelectField';
import { formatOptionLabelWithHighlight } from 'components/forms/multiSelectField/formatOptionLabel';
import { orderBy } from 'utils/arrayUtils';
import { TriggerAddEditModalFormValues } from '../TriggerAddEditModal.schema';
import { getAvailableTemplates } from '../TriggerAddEditModal.utils';

const TriggerAddEditModalTemplateField = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<TriggerAddEditModalFormValues>();
  const actionType = useWatch({ control, name: 'actionType' });
  const { data: triggerOptions, isLoading } = useFetchTriggerOptions();

  if (!actionType) {
    return null;
  }

  const templateOptions = getAvailableTemplates({
    actionType,
    triggerOptions,
  }).map((template) => {
    return {
      label: template.name,
      value: template.uid,
    };
  });

  const options = orderBy(templateOptions, [{ field: 'label', order: 'asc' }]);

  return (
    <CustomSelectField
      colSmInput={12}
      isLoading={isLoading}
      formatOptionLabel={formatOptionLabelWithHighlight}
      label={t('pageAutomations.triggers.modal.templateUid')}
      labelOnTop
      name="templateUid"
      options={options}
      required
    />
  );
};

export default TriggerAddEditModalTemplateField;
